import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import router from './routes'
import { AnimatePresence } from 'framer-motion'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    // <React.StrictMode>
    <AnimatePresence mode="wait">
        <RouterProvider router={router} />
        {/* GOTO ROOT LAYOUT FOR CONTEXT PROVIDERS */}
    </AnimatePresence>
    // </React.StrictMode>
)
